module.exports = __webpack_public_path__ + "static/img/img_0717.3809246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0717.jpg
// module id = 6Fnh
// module chunks = 0